import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Draggable from 'react-draggable';
import ModalDialog from 'react-bootstrap/ModalDialog';

import './styles.scss';

const DraggableModalDialog = props => {
  return (
    <Draggable handle={'.modal-title'}>
      <ModalDialog {...props} />
    </Draggable>
  );
};

interface IStyledModal {
  show: boolean;
  size?: 'sm' | 'lg' | 'xl';
  title?: string | HTMLElement;
  handleClose: () => void;
  children: any;
  titleIcon?: any;
  className?: string;
  showLoadingOverlay?: boolean;
  backdrop?: boolean | 'static' | undefined;
  draggable?: boolean;
  centered?: boolean;
}

const StyledModal = ({
  handleClose,
  show,
  size,
  title,
  children,
  titleIcon,
  className,
  showLoadingOverlay,
  backdrop,
  draggable,
  centered,
}: IStyledModal) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
      }}
      size={size}
      backdrop={backdrop === undefined ? 'static' : backdrop}
      dialogClassName={'styled-modal ' + (className || '')}
      dialogAs={draggable ? DraggableModalDialog : ModalDialog}
      centered={centered}
    >
      {showLoadingOverlay ? (
        <div className="loading-overlay">
          <FontAwesomeIcon icon={['fas', 'spinner']} spin />
        </div>
      ) : null}
      {title ? (
        <Modal.Header closeButton>
          <Modal.Title>
            {titleIcon}
            <b>{title as React.ReactNode}</b>
          </Modal.Title>
        </Modal.Header>
      ) : null}
      {children}
    </Modal>
  );
};

export default StyledModal;
